import { Configuration, PublicClientApplication, SilentRequest } from "@azure/msal-browser";
import axios, { AxiosRequestConfig } from "axios";
import some from "lodash/some";

import store from "../store";
import { Permission } from "../utils/enums";
import { IUser } from "../utils/types/models";

let msalConfig: Configuration;

let _tenantId: string;
let _clientId: string;

let _authClientApplication: PublicClientApplication;

export function setAdCredentials(tenantId: string, clientId: string): void {
	_tenantId = tenantId;
	_clientId = clientId;
}

export function authContext(): PublicClientApplication {
	if (_authClientApplication) {
		return _authClientApplication;
	}

	const tenantId: string = _tenantId;
	const clientId: string = _clientId;

	msalConfig = {
		auth: {
			clientId,
			authority: `https://login.microsoftonline.com/${tenantId}`,
			redirectUri: window.location.origin
		},
		cache: {
			cacheLocation: "localStorage",
			storeAuthStateInCookie: false
		}
	};

	_authClientApplication = new PublicClientApplication(msalConfig);
	_authClientApplication.initialize();

	return _authClientApplication;
}

// tslint:disable-next-line: no-any
export async function fetch(requestOptions: AxiosRequestConfig, authNeeded: boolean): Promise<any> {
	if (!requestOptions.headers) {
		requestOptions.headers = {};
	}
	if (authNeeded) {
		const req: SilentRequest = {
			scopes: [`api://${msalConfig.auth.clientId}/Kovera.Api`],
			account: authContext().getActiveAccount()
		};
		const token: string = (await authContext().acquireTokenSilent(req)).accessToken;
		requestOptions.headers.Authorization = `Bearer ${token}`;
	}
	return axios(requestOptions);
}

export function clearUserCache(): void {
	authContext().clearCache({
		account: authContext().getActiveAccount()
	});
}

export function hasPermission(...permissions: Permission[]): boolean {
	const currentUser: IUser = store.getState().authenticationState.currentUser;

	if (!permissions || permissions.length <= 0) {
		return true;
	}

	if (currentUser) {
		return some(permissions, (permision: string) => {
			return currentUser.permissions[permision];
		});
	}

	return false;
}
